export const BONUS_CONVERSION_TITLE = 'Конвертация бонусов'
export const BONUS_CONVERSION_EMBED_ID = '157034'

export const BONUS_CONVERSION_SUCCESS_TEXT =
	'Скидка активируется в течение 10 минут. Начислить скидку можно только 1 раз за весь период. '

export const BONUS_CONVERSION_PHONE_ERROR_TEXT =
	'Не удалось получить номер телефона из профиля. Попробуйте авторизоваться снова.'

export const BONUS_CONVERSION_REQUEST_ERROR_TEXT = 'Ошибка сервера. Попробуйте еще раз через минуту.'

export const BONUS_CONVERSION_AUTO_FLOW_TIMEOUT_MS = 3000
export const BONUS_CONVERSION_PRELOADER_TIMEOUT_MS = 3000
export const BONUS_CONVERSION_WIDGET_SHOW_DELAY_MS = 180
export const BONUS_CONVERSION_WIDGET_HIDE_DELAY_MS = 250
